@if (vesselEntry(); as vessel) {
  <div class="npdc-title">
    <div id="titleContainer">
      <h1>{{ vessel.content.name }}</h1>
    </div>

    <div class="npdc-title__actions">
      <button mat-button class="npdc-toolbar-button" (click)="onClose()">Close</button>
    </div>
  </div>

  <div class="npdc-layout__content">
    <mat-stepper #stepper orientation="vertical" [linear]="isLinear()">
      <!-- Vessel Description -->

      <mat-step>
        <ng-template matStepLabel>Vessel description</ng-template>
        <form [formGroup]="vesselForm" (ngSubmit)="submit()">
          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Name</mat-label>
              <input matInput type="text" [formControl]="name" />
            </mat-form-field>
          </p>

          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Type</mat-label>
              <input matInput type="text" [formControl]="type" />
            </mat-form-field>
          </p>

          <p>
            <app-form-control-markdown label="Description" [formControl]="description" />
          </p>

          <button mat-flat-button type="submit" [disabled]="!vesselForm.valid">Save</button>
        </form>
      </mat-step>

      <!-- Vessel History -->

      <mat-step>
        <ng-template matStepLabel>History</ng-template>
        <form [formGroup]="historyForm" (ngSubmit)="submit()">
          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Construction year</mat-label>
              <input
                matInput
                type="number"
                placeholder="YYYY"
                min="0"
                [max]="currentYear()"
                [formControl]="constructionYear"
              />
            </mat-form-field>
          </p>

          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Construction place</mat-label>
              <input matInput type="text" [formControl]="constructionPlace" />
            </mat-form-field>
          </p>

          <p>
            <app-form-control-markdown label="History" [formControl]="history" />
          </p>

          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Shipwrecked year</mat-label>
              <input
                matInput
                type="number"
                placeholder="YYYY"
                min="0"
                [max]="currentYear()"
                [formControl]="shipwreckedYear"
              />
            </mat-form-field>
          </p>

          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Shipwrecked location</mat-label>
              <input matInput type="text" [formControl]="shipwreckedLocation" />
            </mat-form-field>
          </p>

          <button mat-flat-button type="submit" [disabled]="!historyForm.valid">Save</button>
        </form>
      </mat-step>

      <!-- Source references to the vessel -->

      <mat-step>
        <ng-template matStepLabel>Sources</ng-template>
        <form [formGroup]="sourcesForm" (ngSubmit)="submit()">
          <p>
            <app-form-control-markdown label="Sources" [formControl]="sources" />
          </p>

          <p>
            <mat-form-field [appearance]="formFieldAppearance()">
              <mat-label>Caption</mat-label>
              <input matInput type="text" [formControl]="caption" />
            </mat-form-field>
          </p>

          <button mat-flat-button type="submit" [disabled]="!sourcesForm.valid">Save</button>
        </form>
      </mat-step>

      <!-- Vessel Owners -->

      <mat-step>
        <ng-template matStepLabel>Owners</ng-template>
        <p>
          @if (ownerList.selectedOptions.selected.length; as length) {
            @if (length === 1) {
              <button
                mat-flat-button
                (click)="openOwnerForm(ownerList.selectedOptions.selected[0].value)"
              >
                Edit
              </button>
            }
            <button mat-button (click)="ownerDelete(ownerList.selectedOptions.selected)">
              Delete
            </button>
          } @else {
            <button mat-flat-button (click)="openOwnerForm()">Add</button>
          }
        </p>
        <mat-selection-list #ownerList>
          @for (owner of vesselEntry().content.owners; track owner; let isLast = $last) {
            <mat-list-option togglePosition="before" [value]="owner">
              <span matListItemTitle>{{ owner.name }}</span>
              @if (owner.location) {
                <span matListItem>{{ owner.location }}</span>
              }
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-step>

      <!-- Vessel Registrations -->

      <mat-step>
        <ng-template matStepLabel>Registrations</ng-template>
        <p>
          @if (registrationList.selectedOptions.selected.length; as length) {
            @if (length === 1) {
              <button
                mat-flat-button
                (click)="openRegistrationForm(registrationList.selectedOptions.selected[0].value)"
              >
                Edit
              </button>
            }
            <button
              mat-button
              (click)="registrationDelete(registrationList.selectedOptions.selected)"
            >
              Delete
            </button>
          } @else {
            <button mat-flat-button (click)="openRegistrationForm()">Add</button>
          }
        </p>
        <mat-selection-list #registrationList>
          @for (
            registration of vesselEntry().content.registrations;
            track registration;
            let isLast = $last
          ) {
            <mat-list-option togglePosition="before" [value]="registration">
              <span matListItemTitle>{{ registration.code }}</span>
              @if (registration.year) {
                <span matListItem><b>Year registered:</b> {{ registration.year }}</span>
              }
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-step>

      <!-- Vessel Harbours -->

      <mat-step>
        <ng-template matStepLabel>Harbours</ng-template>
        <p>
          @if (harbourList.selectedOptions.selected.length; as length) {
            @if (length === 1) {
              <button
                mat-flat-button
                (click)="openHarbourForm(harbourList.selectedOptions.selected[0].value)"
              >
                Edit
              </button>
            }
            <button mat-button (click)="harbourDelete(harbourList.selectedOptions.selected)">
              Delete
            </button>
          } @else {
            <button mat-flat-button (click)="openHarbourForm()">Add</button>
          }
        </p>
        <mat-selection-list #harbourList>
          @for (harbour of vesselEntry().content.harbours; track harbour; let isLast = $last) {
            <mat-list-option togglePosition="before" [value]="harbour">
              <span matListItemTitle>{{ harbour.place }}</span>
              @if (harbour.country) {
                <span matListItem>{{ harbour.country }}</span>
              }
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-step>

      <!-- External links relevant to the vessel -->

      <mat-step>
        <ng-template matStepLabel>Links</ng-template>
        <p>
          @if (linkList.selectedOptions.selected.length; as length) {
            @if (length === 1) {
              <button
                mat-flat-button
                (click)="openLinkForm(linkList.selectedOptions.selected[0].value)"
              >
                Edit
              </button>
            }
            <button mat-button (click)="linkDelete(linkList.selectedOptions.selected)">
              Delete
            </button>
          } @else {
            <button mat-flat-button (click)="openLinkForm()">Add</button>
          }
        </p>
        <mat-selection-list #linkList>
          @for (link of vesselEntry().content.links; track link; let isLast = $last) {
            <mat-list-option togglePosition="before" [value]="link">
              <span matListItemTitle>{{ link.href }}</span>
              @if (link.title) {
                <span matListItemLine>{{ link.title }}</span>
              }
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-step>

      <!-- Image Upload -->

      <mat-step>
        <ng-template matStepLabel>Image upload</ng-template>
        <p>
          <input
            #fileInput
            hidden
            multiple
            name="blob"
            type="file"
            title="blob"
            placeholder="Select one or more images to upload"
            (change)="imageUpload($event)"
          />

          @if (!vesselImages.selectedOptions.selected.length) {
            <button mat-flat-button (click)="fileInput.click()">Upload image</button>
          } @else {
            <button mat-flat-button (click)="imageEdit(vesselImages.selectedOptions.selected)">
              Edit
            </button>
            @if (
              authService.user() &&
              (permissions()?.mayDelete ||
                authService.canInvoke(authService.endpoints.deleteVesselEntry))
            ) {
              <button mat-button (click)="imageDelete(vesselImages.selectedOptions.selected)">
                Delete
              </button>
            }
          }
        </p>

        <mat-selection-list #vesselImages>
          @for (image of images.value()?.items; track image.id; let isLast = $last) {
            <mat-list-option togglePosition="before" [value]="image.id">
              <span matListItemTitle>{{ image.title || image.filename }}</span>
              <span matListItemLine>
                <strong>Prefix:</strong> {{ image.prefix }} <strong>Size:</strong>
                {{ image.byteSize | humanReadableSize }}
              </span>
              @if (image.description) {
                <span matListItemLine> <strong>Attribution:</strong> {{ image.description }} </span>
              }
            </mat-list-option>
          }
        </mat-selection-list>

        <mat-paginator
          showFirstLastButtons
          (page)="onImagePageChange($event)"
          [length]="images.value()?.count"
          [pageIndex]="imagePage()"
          [pageSize]="imagePageSize()"
          [pageSizeOptions]="imagePageSizeOptions"
        />
      </mat-step>
    </mat-stepper>
  </div>
}
